import {
    Action,
    API_USER_GET,
    API_USER_GET_DONE,
    API_USER_GET_ERROR,
    USER_LOG_OUT,
} from "../actions";
import { User } from "../model/user";

export type LoadState = null | "loading" | "done" | "error";

export type UserState = {
    isAuthorized: boolean;
    user: User | null;
    userLoadState: LoadState;
};

const initialState: UserState = {
    isAuthorized: false,
    user: null,
    userLoadState: null,
};

export const userReducer = (
    state: UserState = initialState,
    action: Action,
): UserState => {
    switch (action.type) {
        case API_USER_GET:
            return {
                ...state,
                userLoadState: "loading",
            };
        case API_USER_GET_DONE:
            return {
                ...state,
                isAuthorized: true,
                userLoadState: "done",
                user: action.payload,
            };
        case API_USER_GET_ERROR:
            // todo: offline|unauthorized
            return {
                ...state,
                userLoadState: "error",
                isAuthorized: false,
            };
        case USER_LOG_OUT:
            return initialState;
        default:
            return state;
    }
};
